// components/ui/table/header-table-cell.js
import { TableCell, Typography } from '@mui/material';

const HeaderTableCell = ({ children, sx, ...rest }) => (
  <TableCell sx={{ ...sx }} {...rest}>
    <Typography 
      sx={{ 
        fontWeight: 500, 
        fontSize: '0.675rem', 
        lineHeight: 1, 
        color: 'neutral.600'
      }}>
      {children}
    </Typography>
  </TableCell>
);

export default HeaderTableCell;
